import React, { useCallback } from 'react'
import PropTypes from 'prop-types'

import { useDispatch } from 'react-redux'
import { updateFragmentValue } from 'actions/powerTakeOff'

import { fragmentConfigurationSchema } from 'schemas/validation/fragment'
import { schemaProp } from 'schemas/validation'

import { StyledDynamicInput, StyledInputsWrapper } from './SingleEditor.style'

const rule = schemaProp(fragmentConfigurationSchema)

const SingleEditor = ({ fragment }) => {
  const dispatch = useDispatch()
  const {
    name,
    refNo,
    configuration: { units, value, type, definedValues, translations },
    description,
    moduleNo,
  } = fragment

  const handleChange = useCallback(
    (newValue) => dispatch(updateFragmentValue(refNo, newValue)),
    [refNo, dispatch]
  )

  if (!type) return null

  return (
    <StyledInputsWrapper>
      <StyledDynamicInput
        refNo={refNo}
        name={name}
        units={units}
        value={value}
        description={description}
        moduleNo={moduleNo}
        type={type}
        definedValues={definedValues}
        translations={translations}
        onChange={handleChange}
        makeLabel={() => (units ? `${name} ${units}` : name)}
        rules={rule('value', { definedValues })}
      />
    </StyledInputsWrapper>
  )
}

SingleEditor.propTypes = {
  fragment: PropTypes.shape({
    name: PropTypes.string,
    refNo: PropTypes.string,
    domain: PropTypes.string,
    configuration: PropTypes.shape({
      units: PropTypes.string,
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool,
      ]),
      definedValues: PropTypes.array,
      type: PropTypes.string,
      translations: PropTypes.array,
    }),
    moduleNo: PropTypes.string,
    description: PropTypes.string,
  }),
}

export default SingleEditor
